import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import ServiceDetailsHeader from "../components/Common/ImageHeader";
import CompanyInitiatives from "../components/OurCulture/CompanyInitiatives";
import SliderImages from "../components/OurCulture/SliderImages";
import WorkplaceCultureSurvey from "../components/OurCulture/WorkplaceCultureSurvey";
import TeamActivity from "../components/CareersComponents/JoinUsComponents/JoinUsTeamActivity";
import { Box, Text, Spinner, Alert, AlertIcon } from "@chakra-ui/react";
import {
  ourCultureService,
  extractSliderImages,
  formatHeaderData,
  formatWorkplaceSurvey,
  formatImageGridAsInitiatives,
} from "../services/ourCultureService";
const OurCulture = () => {
  const navigate = useNavigate();
  const [ourCultureData, setOurCultureData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const handleBreadcrumbClick = (href) => {
    if (href && href !== "#") {
      navigate(href);
    }
  };

  // Fetch our culture data on component mount
  useEffect(() => {
    const fetchOurCultureData = async () => {
      try {
        setLoading(true);
        const result = await ourCultureService.getOurCultureData();

        if (result.success) {
          setOurCultureData(result.data);
          setError(null);
        } else {
          setError(result.error);
        }
      } catch (err) {
        console.error("Error fetching our culture data:", err);
        setError("Failed to load our culture data");
      } finally {
        setLoading(false);
      }
    };

    fetchOurCultureData();
  }, []);

  // Extract data from API response - all content is now dynamic
  const headerData = formatHeaderData(ourCultureData?.imageHeader);
  const titleDescData = ourCultureData?.titileDesc;
  const sliderImages = extractSliderImages(ourCultureData);


  // Directly use imageGrid data for company initiatives
  const companyInitiatives = formatImageGridAsInitiatives(
    ourCultureData?.imageGrid
  );


  const workplaceSurvey = formatWorkplaceSurvey(
    ourCultureData?.workplaceSurvey
  );

  // Get dynamic background image or fallback to static one
  const backgroundImage = headerData?.image;

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minH="400px"
      >
        <Spinner size="xl" color="#244034" />
      </Box>
    );
  }

  if (error) {
    return (
      <Box p={8}>
        <Alert status="error">
          <AlertIcon />
          {error}
        </Alert>
      </Box>
    );
  }

  return (
    <>
      <ServiceDetailsHeader
        title={headerData?.title}
        subtitle={headerData?.description}
        backgroundImage={backgroundImage}
        breadcrumbItems={[
          { label: "Home", href: "/" },
          { label: "Our Culture", href: "#", isCurrentPage: true },
        ]}
        onBreadcrumbClick={handleBreadcrumbClick}
      />
      <div
        style={{
          backgroundImage: "url(/png/background.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <Box py={12} px={{ base: 4, md: 6 }}>
          <Box maxW="7xl" mx="auto" textAlign="center">
            <Text
              fontSize={{ base: "2xl", md: "3xl", lg: "4xl" }}
              fontWeight="bold"
              color="#244034"
              mb={4}
            >
              {titleDescData?.title}
            </Text>
            <Text
              fontSize={{ base: "md", md: "lg" }}
              color="gray.600"
              lineHeight="tall"
              textAlign={"justify"}
              whiteSpace="pre-line"
            >
              {titleDescData?.description}
            </Text>
          </Box>
        </Box>

        <CompanyInitiatives initiatives={companyInitiatives} />
        <SliderImages images={sliderImages} autoPlayInterval={4000} />
      </div>

      {/* <ShareIdeasForm /> */}
      <div
        style={{
          backgroundImage: "url(/png/background.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <WorkplaceCultureSurvey surveyData={workplaceSurvey} />
        {/* <TeamActivity /> */}
        <Text>
          Photo gallery
        </Text>
      </div>
    </>
  );
};

export default OurCulture;
